var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-popover',{attrs:{"placement":"right"}},[_c('template',{slot:"content"},[_c('img',{class:_vm.$style['sample'],style:({height: _vm.height + 'px'}),attrs:{"src":_vm.sample_img,"alt":""}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }